import PropTypes from 'prop-types';

const authorizationShape = {
  id: PropTypes.string.isRequired,
  short_id: PropTypes.string,
  state: PropTypes.string,
  approved_cents: PropTypes.number,
  approved_unit_amount: PropTypes.number,
  approved_starts_at: PropTypes.string,
  approved_ends_at: PropTypes.string,
  requested_cents: PropTypes.number,
  requested_unit_amount: PropTypes.number,
  requested_starts_at: PropTypes.string,
  requested_ends_at: PropTypes.string,
  payer_authorization_number: PropTypes.string,
  reviewer_note: PropTypes.string,
  update_request_note: PropTypes.string,
  service_authorization_denial_reason: PropTypes.shape({
    id: PropTypes.string,
    display_name: PropTypes.string,
  }),
  fee_schedule_program: PropTypes.shape({
    unit: PropTypes.string,
  }),
};

export default authorizationShape;
